// src/pages/Concierge/steps/StepShell.jsx
import React from "react";

const LEFT_COPY = {
    1: {
        title: "가입 정보 입력",
        desc:
            "이름·연락처·PIN(6자리)을 수집합니다(필수).\n본인 확인·서비스 안내 외 목적에는 사용하지 않으며, 별도 동의 없이는 마케팅에 활용하지 않습니다.",
    },
    2: {
        title: "가게 정보 입력",
        desc:
            "상호와 업종, 주소(도로명) 기본 정보를 알려 주세요. 이 정보는 AI가 업종과 타깃을 파악해 콘텐츠의 톤, 키워드를 설계하는 데 활용됩니다. 입력은 언제든 수정 가능합니다.",
    },
    3: {
        title: "이미지 업로드",
        desc:
            "대표 메뉴 사진, 가격표, 매장 전경, 행사 이미지 등 홍보에 쓰고 싶은 자료를 올려주세요, 업로드된 자룔를 AI가 자동 분석하여 문구, 이미지, 해시태그를 생성하고, 필요한 경우 디자인 템플릿에 맞춰 리사이즈와 보정까지 수행합니다.(JPG/PNG 구너장, 원본 해상도 유지)",
    },
};

export default function StepShell({
    step,
    total = 3,
    children,
    onPrev,
    onNext,
    onSubmit,
    canNext,
    cardMinH,
}) {
    const copy = LEFT_COPY[step] || LEFT_COPY[1];
    const MIN_H = cardMinH ?? 800;

    return (
        <section className="mx-auto w-full max-w-[1200px]  px-6 md:px-8 py-48">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12 items-start">
                {/* 좌측 설명 */}
                <div className="md:col-span-6">
                    <h2
                        className="text-[34px] md:text-[38px] font-extrabold leading-tight"
                        style={{ color: "var(--primary-600, #6F63F6)" }}
                    >
                        컨시어지 신청
                    </h2>
                    <h3
                        className="mt-2 text-[28px] md:text-[32px] font-extrabold"
                        style={{ color: "var(--ink-strong, #101828)" }}
                    >
                        마케팅 대행서비스
                    </h3>
                    <p
                        className="mt-2 text-[15px] leading-[1.7]"
                        style={{ color: "var(--coolgrey-600, #47526B)" }}
                    >
                        앱 설치 없이, 가입·이미지 제작·게시까지. 대신 마케팅 해드립니다
                    </p>

                    <div className="mt-12 flex gap-4">
                        <div
                            className="w-[2px] rounded"
                            style={{ background: "var(--coolgrey-200, #E3E7EF)" }}
                        />
                        <div>
                            <div
                                className="text-[22px] md:text-[24px] font-extrabold"
                                style={{ color: "var(--ink-strong,#101828)" }}
                            >
                                {step}. {copy.title}
                            </div>
                            <p
                                className="mt-4 whitespace-pre-line text-[15px] leading-[1.8]"
                                style={{ color: "var(--coolgrey-600, #47526B)" }}
                            >
                                {copy.desc}
                            </p>
                        </div>
                    </div>
                </div>

                {/* 우측 카드 */}
                <div className="md:col-span-6">
                    <div
                        className="rounded-[8px] border bg-white p-6 md:p-8 flex flex-col"
                        style={{ borderColor: "var(--coolgrey-200,#E3E7EF)", minHeight: MIN_H }}
                    >
                        {/* 스텝 인디케이터 */}
                        <div className="mb-6 flex items-center gap-2">
                            {Array.from({ length: total || 3 }, (_, i) => i + 1).map((n) => (
                                <div
                                    key={n}
                                    className={`w-7 h-7 rounded-full flex items-center justify-center text-sm ${n === step ? "text-white" : ""
                                        }`}
                                    style={{
                                        background:
                                            n === step
                                                ? "var(--primary-500, #654AEE)"
                                                : "var(--coolgrey-100, #EAEEF4)",
                                        color: n === step ? "#FFF" : "var(--ink-default, #1F2937)",
                                    }}
                                >
                                    {n}
                                </div>
                            ))}
                        </div>


                        {/* 제목/보조문구 */}
                        <div className="mb-6">
                            <div
                                className="text-[20px] md:text-[22px] font-extrabold"
                                style={{ color: "var(--ink-strong,#101828)" }}
                            >
                                {copy.title}
                            </div>
                            <p
                                className="mt-2 text-[14px]"
                                style={{ color: "var(--coolgrey-600,#47526B)" }}
                            >
                                가입 진행을 위한 필수 정보를 입력해 주세요.
                            </p>
                        </div>

                        {/* 실제 스텝 컨텐츠 */}
                        <div className="flex-1">{children}</div>
                    </div>

                    {/* ── 카드 외부 버튼 (색상 지정 없음) ───────────────── */}
                    {step === 1 && (
                        <div className="mt-8">
                            {/* 1단계: 다음만 단일 버튼 */}
                            <button
                                type="button"
                                className="h-10 w-full rounded-md border disabled:opacity-50 disabled:cursor-not-allowed text-black border-gray-500"
                                onClick={onNext}
                                disabled={!canNext}
                            >
                                다음
                            </button>
                        </div>
                    )}

                    {step === 2 && (
                        <div className="mt-8 flex gap-10">
                            {/* 2단계: 이전 / 다음 */}
                            <button
                                type="button"
                                className="h-10 flex-1 rounded-md border text-black border-gray-500"
                                onClick={onPrev}
                            >
                                이전
                            </button>
                            <button
                                type="button"
                                className="h-10 flex-1 rounded-md border disabled:opacity-50 disabled:cursor-not-allowed text-black border-gray-500"
                                onClick={onNext}
                                disabled={!canNext}
                            >
                                다음
                            </button>
                        </div>
                    )}

                    {step === 3 && (
                        <div className="mt-8 flex gap-10">
                            {/* 3단계: 이전 / 신청하기 */}
                            <button
                                type="button"
                                className="h-10 flex-1 rounded-md border text-black border-gray-500"
                                onClick={onPrev}
                            >
                                이전
                            </button>
                            <button
                                type="button"
                                className="h-10 flex-1 rounded-md border disabled:opacity-50 disabled:cursor-not-allowed text-black border-gray-500"
                                onClick={onSubmit}
                                disabled={!canNext}
                            >
                                신청하기
                            </button>
                        </div>
                    )}
                    {/* ──────────────────────────────────────────────── */}
                </div>
            </div>
        </section>
    );
}
